module.exports = __webpack_public_path__ + "static/media/whitelogo.1cf2126f.png";